<template>
<div class="item-base" v-if="UiRight.photoList">
  <el-image :src="'http://'+ UiRight.photoList[0].address" class="img" fit="cover"></el-image>
</div>
</template>

<script>
export default {
  name: "ProductRight",
  props:{
    UiRight:{

    }
  }
}
</script>

<style lang="less" scoped>
  .item-base{
    width: 210px;
    min-width: 210px;
    height: 50.9vh;
    .img{
      width: 100%;
      height: 100%;
    }
  }
</style>